export const REACT_LIKE_ICON = "itaufonts_curtir";
export const REACT_LIKE_FULL_ICON = "itaufonts_full_curtir";
export const REACT_UNLIKE_ICON = "itaufonts_descurtir";
export const REACT_UNLIKE_FULL_ICON = "itaufonts_full_descurtir";
export var ReactIconTypes;
(function (ReactIconTypes) {
    ReactIconTypes["like"] = "like";
    ReactIconTypes["unlike"] = "unlike";
})(ReactIconTypes || (ReactIconTypes = {}));
//# sourceMappingURL=constants.js.map